import { css } from 'styled-components';
import { cvBreakpoint1024 } from '@carvana/theme';
import 'react-dates/lib/css/_datepicker.css';

const dayPickerStyles = css`
  .DayPicker__withBorder {
    box-shadow: none;
    width: 330px !important;
  }

  .DayPickerNavigation_button {
    position: absolute;
    top: 24px;

    &:first-of-type {
      left: 240px;
    }

    &:last-of-type {
      right: 4px;
    }

    & svg {
      height: 16px;
      width: 16px;
    }

    & svg > g {
      fill: ${props => props.theme.carvana.blue.primary};
    }
  }

  .CalendarMonth {
    padding: 0px !important;
  }

  .CalendarMonthGrid {
    left: 0px !important;
  }


  .CalendarMonth_caption {
    color: ${props => props.theme.carvana.gray.dark};
    text-align: left;
    font-size: 14px;
  }

  .DayPicker_weekHeader {
    top: 54px;
    padding: 0px !important;
  }

  .DayPicker_weekHeader_ul {
    width: 360px;
  }

  .DayPicker_weekHeader_li {
    color: ${props => props.theme.carvana.blue.dark};
    font-weight: bold;
    font-size: 1rem;
    width: 45px !important;
  }

  .DayPicker_weekHeaders__horizontal {
    margin-left: 0px;
  }

  .DayPicker_transitionContainer {
    height: 360px !important;

    @media (min-width: ${cvBreakpoint1024}px) {
      width: 360px !important;
    }
  }

  .CalendarMonth_table {
    border-spacing: 5px;
    border-collapse: separate;
  }

  .CalendarDay {
    border-radius: 5px;
    border: 1px solid ${props => props.theme.carvana.gray.light};
    color: ${props => props.theme.carvana.gray.dark};
    position: relative;
    z-index: 1;

    &:hover {
      background-color: transparent;
      border-radius: 5px;
      border: 1px solid ${props => props.theme.carvana.gray.dark};
      border-bottom: 1.5px solid ${props => props.theme.carvana.gray.dark};
      color: ${props => props.theme.carvana.gray.dark};
    }
  }

  .CalendarDay__selected {
    background: ${props => props.theme.carvana.blue.hover};
    border: 1px solid ${props => props.theme.carvana.blue.hover};
    border-radius: 5px;
    color: white;

    &:hover {
      background-color: ${props => props.theme.carvana.blue.hover};
      border: 1px solid ${props => props.theme.carvana.blue.hover};
      border-radius: 5px;
      color: white;
    }
  }

  .CalendarDay__blocked_calendar {
    background-color: ${props => props.theme.carvana.gray.light};
    border: 1px solid ${props => props.theme.carvana.gray.light};
    border-radius: 5px;

    &:hover {
      background-color: ${props => props.theme.carvana.gray.light};
      border: 1px solid ${props => props.theme.carvana.gray.light};
      border-radius: 5px;
    }
  }
`;

export default dayPickerStyles;
